import { render } from "./App.vue?vue&type=template&id=168b9c2e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=168b9c2e&lang=less"

import exportComponent from "D:\\webproject\\instutite\\demo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__